module.exports = __webpack_public_path__ + "static/media/trustpilot-white.b9de8774.svg";